/* RESPONSIBLE TEAM: team-data-foundations */
export default class TextNode {
  constructor(value) {
    this.value = value;
    this.type = 'text';
  }
}
